import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL, ACCENT_IMAGES } from "@/data/brand";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) { toast.error(res.error || "Login fallito"); return; }
    toast.success("Benvenuto!");
    nav(params.get("redirect") || "/dashboard");
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-[calc(100vh-64px)]" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={ACCENT_IMAGES[0]} alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-black/70"></div>
        <div className="absolute bottom-10 left-10 right-10">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFBE00] mb-2">· Bentornato</div>
          <h2 className="font-heading font-black text-4xl leading-tight">La tua <span className="text-[#E619A8]">piattaforma</span> ti aspetta.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <Link to="/"><img src={LOGO_URL} alt="HostMarket" className="h-10 w-auto mb-10" /></Link>
          <h1 className="font-heading font-black text-3xl mb-2">Accedi</h1>
          <p className="text-sm text-zinc-500 mb-8">Non hai un account? <Link to="/registrati" className="text-[#FFBE00] hover:underline">Registrati</Link></p>
          <div className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Email</label>
              <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#FFBE00] focus:ring-1 focus:ring-[#FFBE00] outline-none" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Password</label>
              <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#FFBE00] focus:ring-1 focus:ring-[#FFBE00] outline-none" />
            </div>
            <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#E619A8] hover:text-white transition-all disabled:opacity-50" data-testid="login-submit">
              {loading ? "Accesso…" : "Accedi"}
            </button>
            <div className="flex items-center justify-between text-xs text-zinc-500 pt-2">
              <Link to="/recupera-password" className="hover:text-[#FFBE00]" data-testid="login-forgot-link">Password dimenticata?</Link>
              <Link to="/rivendica" className="hover:text-[#E619A8]" data-testid="login-claim-link">Rivendica annuncio</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
